export default class extends HTMLElement {

  constructor() {
    super();
    console.log('Init DSBQuiz');
    this.questions = {};
    this.hooks = {};
    this.settings = {};
    this.footer = [];
    this.complete = '';
    this.fail = '';
  }

  init()
  {
     this.setAttribute(`id`, 'dsb-quiz_'+this._createUUID());
  }

  _createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  _shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  _merge(args){

    // create a new object
    let target = {};

    // deep merge the object into the target object
    const merger = (obj) => {
        for (let prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                    // if the property is a nested object
                    target[prop] = this._merge([target[prop], obj[prop]]);
                } else {
                    // for regular property
                    target[prop] = obj[prop];
                }
            }
        }
    };

    // iterate through all objects and
    // deep merge them with target
    for (let i = 0; i < args.length; i++) {
        merger(args[i]);
    }

    return target;
};

  get service() {
      return this.getAttribute('service');
  }

  set service(newValue){
      this.setAttribute('service', newValue);
  }


  addSetting(name, value)
  {

    this.settings[name] = value;
    return true;
  }

  getSetting(name)
  {
    if(typeof this.settings === 'object' && this.settings !== null)
    {
      if(name in this.settings)
      {
        return this.settings[name];
      }
    }
    else
    {
      this.settings = {};
    }
    return;
  }


  get template_path() {
      return this.getAttribute('template_path');
  }

  set template_path(newValue){
      this.setAttribute('template_path', newValue);
  }

  get source_id() {
      return this.getAttribute('source_id');
  }

  set source_id(newValue){
      this.setAttribute('source_id', newValue);
  }

  get source_type() {
      return this.getAttribute('source_type');
  }

  set source_type(newValue){
      this.setAttribute('source_type', newValue);
  }

  get name() {
      return this.getAttribute('name');
  }

  set name(newValue){
      this.setAttribute('name', newValue);
  }

  get submit_button_name() {
      return this.getAttribute('submit_button_name');
  }

  set submit_button_name(newValue){
      this.setAttribute('submit_button_name', newValue);
  }

  setDSBClient(dsbClient){
      this.dsbClient=dsbClient;
  }

  setQuizContent(data){
      this.quiz_content=data;
  }

  setQuestion(part_id, question_id, question, options, type, value='', pattern = '', pattern_message = ''){
      this.questions[part_id+'-'+question_id]={'question_id':question_id,'part_id':part_id,'question':question,'options':options,'type':type,'pattern':pattern,'pattern_message':pattern_message,'value':value};
  }

  addHook(name,action){
      this.hooks[name] = action;
  }

  addFooter(data){
      this.footer.push(data);
  }

  resetFooter(){
      this.footer = [];
  }

  connectedCallback()
  {
    return this._render();
  }


  async _render()
  {


    this.innerHTML = `<maa-spinner></maa-spinner>`;
    var controller = this;
    let current_user_data = await controller.dsbClient.user.get('cpd', '?type=collection&link_type='+controller.source_type+'&link_value='+controller.source_id+'&iteration[sort]=desc&_[limit]=1',true);

    if(!current_user_data)
    {
      current_user_data = {};
      current_user_data.data={};
    }

    if(this.questions)
    {
      this.form_panel = document.createElement("form");
      let form_submission = document.createElement("input");
      let message_panel = document.createElement("section");
      message_panel.setAttribute(`class`, `message`);
      let message_ol = document.createElement("ol");
      message_panel.append(message_ol);
      let footer_panel_submit = document.createElement("section");
      let footer_panel_navigate = document.createElement("section");


      form_submission.type = 'submit';
      form_submission.value = (this.submit_button_name?this.submit_button_name:'Submit');
      if(controller.dsbClient.user.is_offline())
      {
        form_submission.disabled = true;
      }
      else
      {
        // Check for submit hooks
        if('_on_form_submit' in this.hooks)
        {
          this.form_panel.addEventListener('submit', this.hooks.on_form_submit);
        }
        else
        {
          this.form_panel.addEventListener('submit', async event => {
            // submit event detected
            event.preventDefault()

            let spinner = document.createElement('maa-spinner');
            spinner.setAttribute('type','inline-small');
            footer_panel_submit.prepend(spinner);
            let cpd = JSON.parse(JSON.stringify(current_user_data));

            //let message_panel = controller.id+'_messages';
            cpd.type = 'collection';
            cpd.link_type = controller.source_type;
            cpd.link_value = controller.source_id;
            cpd.name = controller.name;

            if(typeof cpd.data === 'object' && cpd.data !== null)
            {
             // Nice :)
            }
            else
            {
              cpd.data = {};
            }

            let aMessage = document.createElement("li");
            aMessage.setAttribute(`class`,`icon-error`);
            aMessage.innerHTML=`Sorry, an error seems to have occured.<br/>Please try again later.`;

            //post.date = controller.dsbClient.user.getDate();

            const formData = new FormData(event.target);
            const entries = formData.entries();
            let submission = Object.fromEntries(entries);

            let cpd_data = {};
            let submission_count = 0;
            for(let aSubmission in submission)
            {
              let path = aSubmission.split('-');
              submission_count++;
              let parent = {};
              let parent_ref = parent;
              for(let i = 0; i < path.length; i++)
              {
                if(i == (path.length -1))
                {
                  parent_ref[path[i]] = submission[aSubmission];
                  continue;
                }
                else
                {
                  parent_ref[path[i]] = {};
                }
                parent_ref = parent_ref[path[i]];
              }
              cpd_data = controller._merge([cpd_data, JSON.parse(JSON.stringify(parent))]);
            }

            if(submission_count == 0)
            {
              aMessage.innerHTML=`Please complete all fields.`;
            }
            else
            {

              let currentPart = [];
              // Import into cpd
              for(let cpd_data_part in cpd_data)
              {
                currentPart.push(cpd_data_part);
                if(cpd_data_part in cpd.data)
                {
                  delete cpd.data[cpd_data_part];
                }
              }
              cpd.data = controller._merge([cpd.data, JSON.parse(JSON.stringify(cpd_data))]);

              let returned = await controller.dsbClient.user.post('cpd', cpd);

              if(returned)
              {
                if('progress' in returned)
                {
                  let progress_success = 0;
                  let progress_total = 0;
                  for(let aField in returned.progress)
                  {
                    if(returned.progress[aField] == true)
                    {
                      progress_success++;
                    }
                    progress_total++;
                  }

                  try
                  {

                    for(let i = 0; i < currentPart.length; i++)
                    {
                      // Check for progress_questions
                      if(this.getSetting('show_incorrect_ans') == true && 'progress_questions' in returned)
                      {
                        if(currentPart[i] in returned.progress_questions)
                        {
                          for(let apartQuestion in returned.progress_questions[currentPart[i]])
                          {
                            let failedPanel = document.getElementById('panel-'+apartQuestion);

                            if(failedPanel.classList.contains('false'))
                            {
                              failedPanel.classList.remove('false');
                            }

                            if(returned.progress_questions[currentPart[i]][apartQuestion]==false)
                            {
                              failedPanel.classList.add('false');
                            }
                          }
                        }
                      }

                      // Check part progress
                      if(currentPart[i] in returned.progress)
                      {
                        if(returned.progress[currentPart[i]] == true)
                        {
                          aMessage.setAttribute(`class`,`icon-check-circ`);
                          aMessage.innerHTML=`Success. You have now completed `+progress_success+` of `+progress_total+` parts.`;
                          footer_panel_submit.setAttribute('style','display:none');
                          footer_panel_navigate.setAttribute('style','display:flex');
                          if('on_success' in controller.hooks)
                          {
                            controller.hooks.on_success(controller);
                          }
                          if(progress_success == progress_total)
                          {
                            if('on_complete' in controller.hooks)
                            {
                              await controller.hooks.on_complete(controller, cpd.data);
                            }
                          }
                        }
                        else
                        {
                          aMessage.setAttribute(`class`,`icon-error`);
                          aMessage.innerHTML=`One or more of your answers is wrong.<br/>Please review your answers and try again or <span style="cursor:pointer;text-decoration: underline;" onclick="window.dispatchEvent(new CustomEvent('dsb-pwa-trigger_tray', {detail: {name:'feedback'}}));return false;">report a problem.</span>`;
                          if('on_fail' in controller.hooks)
                          {
                            controller.hooks.on_fail(controller);
                          }
                          break;
                        }
                      }
                    }
                  }
                  catch(ex)
                  {
                    aMessage.setAttribute(`class`,`icon-error`);
                    console.error('currentPart processing error',ex);
                    aMessage.innerHTML=`Sorry, something went wrong.<br/>Please try again or <span style="cursor:pointer;text-decoration: underline;" onclick="window.dispatchEvent(new CustomEvent('dsb-pwa-trigger_tray', {detail: {name:'feedback'}}));return false;">report a problem.</span>`;
                    if('on_fail' in controller.hooks)
                    {
                      controller.hooks.on_fail(controller);
                    }
                  }
                }
              }
            }

            message_ol.innerHTML = ``;
            message_ol.append(aMessage);
            spinner.remove();
            return true;
          });
        }
      }

      let question_count = 0;
      let parts = {};
      for(let question in this.questions)
      {
        question_count++;
        parts['part_'+this.questions[question].part_id]=true;
        let fieldset_panel = document.createElement("fieldset");
        fieldset_panel.id = 'panel-question_'+this.questions[question].question_id;
        if(this.getSetting('show_count') == true)
        {
          fieldset_panel.classList.add('show-count');
        }
        fieldset_panel.innerHTML = "<p>"+this.questions[question].question+"</p>";
        if('options' in this.questions[question] && this.questions[question].type.startsWith(`checkbox`))
        {
          let options = document.createElement("ol");
          options.id = 'question_'+this.questions[question].question_id;

          let list = [];
          let randomize = false;
          let trueCount = 0;

          // Prepare multi ans
          for(let i = 0; i < this.questions[question].options.length; i++)
          {
            if('answer' in this.questions[question].options[i])
            {
              if(this.questions[question].options[i].answer.toLowerCase() == 'true')
              {
                trueCount++;
              }
            }
          }

          let onclick__checkbox_radio = false;
          if(trueCount == 1)
          {
            onclick__checkbox_radio = function(){
              let group = document.getElementById(this.getAttribute("data-group"));
              let inputs = group.querySelectorAll(`input`);
              if(inputs !== undefined || inputs.length > 0)
              {
                for(let i = 0; i < inputs.length; i++)
                {
                  inputs[i].checked = false;
                }
              }
              this.checked = true;
            }
          }

          for(let i = 0; i < this.questions[question].options.length; i++)
          {
            let questions_element = document.createElement("li");
            let name = 'part_'+this.questions[question].part_id+'-question_'+this.questions[question].question_id+'-option_'+this.questions[question].options[i].uid;
            let id = this.id+'_'+name;
            let value = this.questions[question].options[i].option;
            if(value)
            {
              if((value.indexOf("https://") == 0) || (value.indexOf("http://") == 0))
              {
                let _value = value;
                value = document.createElement('img');
                value.src = _value;
                value.width = "300";
              }
            }

            let input_element = ``;

            switch(this.questions[question].type)
            {
              case "checkbox_random":
                randomize = true;
              case "checkbox":
                input_element = document.createElement('input');
                input_element.type = 'checkbox';
                input_element.id = id;
                input_element.name = name;
                input_element.value = 'true';
                input_element.setAttribute('data-group',options.id);
                // Set
                if(current_user_data !== null && typeof current_user_data === 'object')
                {
                  if(current_user_data.data !== null && typeof current_user_data.data === 'object' && ('data' in current_user_data))
                  {
                    if('part_'+this.questions[question].part_id in current_user_data.data)
                    {
                      if('question_'+this.questions[question].question_id in current_user_data.data['part_'+this.questions[question].part_id])
                      {
                        if('option_'+this.questions[question].options[i].uid in current_user_data.data['part_'+this.questions[question].part_id]['question_'+this.questions[question].question_id])
                        {
                          if(current_user_data.data['part_'+this.questions[question].part_id]['question_'+this.questions[question].question_id]['option_'+this.questions[question].options[i].uid] == 'true')
                          {
                            input_element.setAttribute(`checked`,`checked`);
                          }
                        }
                      }
                    }
                  }
                }
                if(onclick__checkbox_radio)
                {
                  input_element.setAttribute(`class`,`radiobutton`);
                  input_element.onclick = onclick__checkbox_radio;
                }
                break;
              default:
                break;
            }


            let label_element = document.createElement('label')
            label_element.htmlFor = id;
            //label_element.appendChild(document.createTextNode(this.questions[question].options[i].option));
            if(value instanceof HTMLElement)
            {
              label_element.appendChild(value);
            }
            else
            {
              label_element.appendChild(document.createTextNode(value))
            }
            questions_element.append(input_element);
            questions_element.append(label_element);
            list.push(questions_element);
          }

          if(randomize)
          {
            this._shuffle(list);
          }
          for(let i = 0; i < list.length; i++)
          {
            options.append(list[i]);
          }
          fieldset_panel.append(options);
        }
        else
        {
          let answers = document.createElement("ol");
          let questions_element = document.createElement("li");
          let name = 'part_'+this.questions[question].part_id+'-question_'+this.questions[question].question_id;
          let id = this.id+'_'+name;

          let input_element = ``;

          switch(this.questions[question].type)
          {
            case "text":
              input_element = document.createElement('input');
              input_element.type = 'text';
              input_element.id = id;
              input_element.name = name;
              input_element.value = ((`value` in this.questions[question])?this.questions[question].value:``);

              if('pattern' in this.questions[question] && this.questions[question].pattern.length>0)
              {
                input_element.pattern = this.questions[question].pattern;
                input_element.title = 'Incorrect format, please try again.';
                if('pattern_message' in this.questions[question] && this.questions[question].pattern_message.length>0)
                {
                  input_element.title = this.questions[question].pattern_message;
                }
              }

              // Set
              if(typeof current_user_data === 'object' && current_user_data !== null)
              {
                if('data' in current_user_data)
                {
                  if('part_'+this.questions[question].part_id in current_user_data.data)
                  {
                    if('question_'+this.questions[question].question_id in current_user_data.data['part_'+this.questions[question].part_id])
                    {
                      input_element.value = current_user_data.data['part_'+this.questions[question].part_id]['question_'+this.questions[question].question_id];
                    }
                  }
                }
              }

              break;
            default:
              break;
          }
          questions_element.append(input_element);
          answers.append(questions_element);
          fieldset_panel.append(answers);

        }
        this.form_panel.append(fieldset_panel);
      }
      this.innerHTML = ``;


      // Check for completion
      let is_complete = false;
      if(current_user_data)
      {
        if('progress' in current_user_data)
        {
          let count_fails = 0;
          let count = 0;
          for(let thispart in parts)
          {
            if(!(thispart in current_user_data.progress))
            {
              count_fails++;
            }
            else if(current_user_data.progress[thispart] == false)
            {
              count_fails++;
            }
          }
          if(count_fails == 0)
          {
            is_complete = true;
          }
        }
      }

      footer_panel_submit.append(form_submission);
      for(let i = 0; i < this.footer.length; i++)
      {
          footer_panel_navigate.append(this.footer[i]);
      }


      if(is_complete)
      {
        footer_panel_submit.setAttribute('style','display:none');
        footer_panel_navigate.setAttribute('style','display:flex');

        let aMessage = document.createElement("li");
        aMessage.setAttribute(`class`,`icon-check-circ`);
        aMessage.innerHTML=`You have already completed this part.`;
        message_ol.innerHTML = ``;
        message_ol.append(aMessage);
      }
      else
      {
        footer_panel_navigate.setAttribute('style','display:none');
        footer_panel_submit.setAttribute('style','display:flex');
      }

      this.form_panel.append(message_panel);
      this.form_panel.append(footer_panel_submit);
      this.form_panel.append(footer_panel_navigate);
      this.append(this.form_panel);
    }
    return;
  }
}


